type StandaloneNavigator = Navigator & { standalone?: boolean };

/**
 * `true` when the page runs as an installed app: the `standalone` display mode, or the iOS-only
 * `navigator.standalone` flag. Both are runtime checks since jsdom and older browsers omit them.
 */
const isStandaloneDisplay = (): boolean => {
	try {
		if (
			typeof window.matchMedia === 'function' &&
			window.matchMedia('(display-mode: standalone)').matches
		) {
			return true;
		}

		return 'standalone' in navigator && (navigator as StandaloneNavigator).standalone === true;
	} catch {
		return false;
	}
};

export default isStandaloneDisplay;
